import {
  AdminCreateUsageBillingUrlRequestBodyType,
  AdminCreateUsageBillingUrlResponseBodyType,
} from "@intelligems/ig-types";
import { useMutation } from "@tanstack/react-query";

import { api } from "../api";
import { ApiRequest } from "../types/api";

const adminGetUsageBillingUrl = async (
  data: ApiRequest<AdminCreateUsageBillingUrlRequestBodyType>
) => {
  const resp = await api.post<AdminCreateUsageBillingUrlResponseBodyType>(
    "/v2/admin/usage-billing-url",
    data.body
  );
  return resp.data;
};

export const useAdminCreateUsageBillingUrl = () => {
  return useMutation<
    AdminCreateUsageBillingUrlResponseBodyType,
    Error,
    ApiRequest<AdminCreateUsageBillingUrlRequestBodyType>,
    any
  >({
    mutationKey: ["admin-request-billing-url"],
    mutationFn: async (data) => adminGetUsageBillingUrl(data),
  });
};
